export const projectOne = {
  name: 'Phone Factor',
  description: 'A Inventory or Factory Products Management website build by React Js. server side was built by express JS.',
  img: ['https://i.ibb.co/Ct2Sv0y/phone-factor.png', 'https://i.ibb.co/Dp60bbH/tabular-inventory-phone-factor.png' , 'https://i.ibb.co/MZ2vdBy/loginpage.png' , ],
  liveLink: 'https://phone-factor.web.app/',
  gitRepoClient: 'https://github.com/checkiamsiam/phone-factory-a-warehouse-or-inventory-web',
  gitRepoServer: 'https://github.com/checkiamsiam/phone-factor-server',
  detailsRoute: 'phone-factor',
  featured: false,
  category: 'org',
  technologyUsed: ['React Js', 'Express Js', 'MongoDB Atlas', 'Node Js', 'Tailwind Css', 'Firebase Authentication', 'Heroku', 'Github'],
  specialty: [
    'Advance Secure Firebase Authentication',
    'Great Looking User Interface',
    'Amazing User Experience',
    'Little bit Animation',
    'Hover Effected Card',
    'Managing Product(CURD)',
    'Amazing Database & ui intersection',
    'Advance Product Management Calculation'
  ]
}

export const  projectTwo = {
  name : 'Take Tutor',
  description : 'A website for independent service provider, an teacher are showing his services for students',
  img: ['https://i.ibb.co/JyGrhPG/take-tutor.png', 'https://i.ibb.co/4S4tFBJ/services-tutot.png' , 'https://i.ibb.co/ygjgxTh/contact-tutor.png'] ,
  liveLink : 'https://take-tutor.web.app/',
  gitRepoClient : 'https://github.com/checkiamsiam/bycycle-soul-manufacturing' ,
  detailsRoute : 'take-tutor', 
  featured : false ,
  category : 'personal',
  technologyUsed : ['React Js' , 'Tailwind Css' , 'React Router Dom' , 'React Query' , 'React Rating' , 'Swiper Js' , 'React Scroll' ] ,
  }
export const  projectThree = {
  name : 'Amazon Clone',
  description : 'I was trying to clone amazon e-commerce. only few featured are added.',
  img: ['https://i.ibb.co/XWrj2ZM/amazon-clone.png', 'https://i.ibb.co/pxpGn8c/order.png' , 'https://i.ibb.co/Y7JGwPL/shop-ema-min.png'] ,
  liveLink : 'https://ema-john-checkiamsiam.netlify.app/',
  gitRepoClient : 'https://github.com/checkiamsiam/try-to-clone-amazon' ,
  detailsRoute : 'amazon', 
  featured : false ,
  category : 'org',
  technologyUsed : ['React Js' , 'Vanilla Css' , 'React Router Dom' , 'Firebase' , 'React-Firebase-Hooks' , 'Rest Api'] ,
  }
export const  projectFour = {
  name : 'Movie Review(RRR)',
  description : 'A blog website for practicing react router and and when i was making this, rrr film was released at that time',
  img: ['https://i.ibb.co/yyxd5Yh/rrr-review.png', 'https://i.ibb.co/YfMVJQf/blogs-review.png' , 'https://i.ibb.co/rQBWZP4/charts.png'] ,
  liveLink : 'https://movie-review-checkiamsiam.netlify.app/',
  gitRepoClient : 'https://github.com/checkiamsiam/RRR-movie-review-site-react-router' ,
  detailsRoute : 'rrr-review', 
  featured : false ,
  category : 'all',
  technologyUsed : ['React Js' , 'Tailwind Css' , 'React Router Dom' , 'Re-Charts'] ,
  }
export const  projectFive = {
  name : 'Bibaho Bonton',
  description : 'An website for convention center using bootstrap css',
  img: ['https://i.ibb.co/Gvwhp7Z/bibaho-bonton-min.png', 'https://i.ibb.co/hBWL8D1/toasted-min.png' , 'https://i.ibb.co/qdNZxVs/acordion-and-comments-min.png'] ,
  liveLink : 'https://bibaho-bonton.netlify.app/',
  gitRepoClient : 'https://github.com/checkiamsiam/bootstrap-based-project-bibaho-bonton' ,
  detailsRoute : 'bibaho-bonton', 
  featured : false ,
  category : 'all',
  technologyUsed : ['Html'  , 'Vanilla Css' , 'Bootstrap Css'] ,
  }